import {
  Button,
  Col,
  Collapse,
  Divider,
  Dropdown,
  Empty,
  List,
  Menu,
  message,
  Row,
  Space,
  Spin,
} from "antd";
import { Link } from "react-router-dom";
import "./VisitList.css";
import useAuthorizationData from "../../utils/useAuthorizationData";
import { MenuOutlined, IdcardOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";
import { VisitInfo } from "../../types/visitTypes";
import visitService from "../../services/visitService";

const VisitList = () => {
  const [visits, setVisits] = useState<VisitInfo[] | undefined>(undefined);
  const [authorizationData] = useAuthorizationData();
  const { Panel } = Collapse;

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchData = async () => {
    if (authorizationData !== undefined) {
      const visitInfo = await visitService.GetVisitList(authorizationData.id);

      if (visitInfo == null) {
        message.error("Fetching visit Failed");
      }
      if (visitInfo && visitInfo.data && visitInfo.data.length > 0) {
        const data = visitInfo.data.map(
          (visit) =>
            ({
              Id: visit.Id,
              ShipName: visit.ShipName,
              VisitStartDate: new Date(visit.VisitStartDate),
              VisitEndDate: new Date(visit.VisitEndDate),
              Port: visit.Port,
              Status: visit.Status,
              Visitors: visit.Visitors,
            } as VisitInfo)
        );
        setVisits(data);
      } else {
        setVisits([]);
      }
    }
  };

  function ShowList(itemsCount: number | undefined) {
    if (itemsCount === undefined) {
      return (
        <div className="visit-list-spin">
          <Spin />
        </div>
      );
    } else if (itemsCount === 0) {
      return (
        <Empty
          className="visit-list-empty"
          imageStyle={{
            height: 160,
          }}
          description={
            <div>
              <Space direction="vertical">
                <h1>empty here</h1>
                <h3>you do not have any scheduled visits yet</h3>
              </Space>
            </div>
          }
        />
      );
    } else {
      return (
        <List
          grid={{
            gutter: 16,
            column: 1,
          }}
          pagination={{
            onChange: (page) => {
              console.log(page);
            },
            pageSize: 10,
          }}
          dataSource={visits}
          renderItem={(item) => (
            <List.Item key={item.Id}>
              <Collapse
                className="visit-list-collapse"
                expandIconPosition="left"
              >
                <Panel
                  showArrow={false}
                  header={
                    <Row className="visit-list-collapse-row ">
                      <Col xs={20} sm={20} md={20} lg={20} xl={20} xxl={20}>
                        <Row>
                          <Col xs={24} sm={12} md={6} lg={6} xl={6} xxl={4}>
                            ship:
                            <br />
                            <span className="visit-list-text">
                              {item.ShipName}
                            </span>
                          </Col>
                          <Col xs={24} sm={12} md={6} lg={6} xl={6} xxl={4}>
                            visit start date:
                            <br />
                            <span className="visit-list-text">
                              {item.VisitStartDate.toLocaleDateString()}
                            </span>
                          </Col>
                          <Col xs={24} sm={12} md={6} lg={6} xl={6} xxl={4}>
                            visit end date:
                            <br />
                            <span className="visit-list-text">
                              {item.VisitEndDate.toLocaleDateString()}
                            </span>
                          </Col>
                          <Col xs={24} sm={12} md={6} lg={6} xl={6} xxl={4}>
                            port:
                            <br />
                            <span className="visit-list-text">{item.Port}</span>
                          </Col>
                          <Col xs={24} sm={12} md={6} lg={6} xl={6} xxl={4}>
                            status:
                            <br />
                            <span className="visit-list-text">
                              {item.Status}
                            </span>
                          </Col>
                        </Row>
                      </Col>
                      <Col
                        className="visit-list-item-menu"
                        xs={4}
                        sm={4}
                        md={4}
                        lg={4}
                        xl={4}
                        xxl={4}
                      >
                        <Dropdown overlay={menu}>
                          <MenuOutlined
                            onClick={(event) => {
                              event.stopPropagation();
                            }}
                          />
                        </Dropdown>
                      </Col>
                    </Row>
                  }
                  key="1"
                >
                  {item.Visitors.map((visitor) => (
                    <Row>
                      {item.Visitors[0].Id !== visitor.Id ? <Divider /> : ""}
                      <Col xs={24} sm={12} md={16} lg={18} xl={18} xxl={20}>
                        <Row>
                          <Col
                            className="visit-list-group"
                            xs={24}
                            sm={24}
                            md={24}
                            lg={24}
                            xl={12}
                            xxl={8}
                          >
                            <Row>
                              <Col
                                xs={24}
                                sm={24}
                                md={10}
                                lg={6}
                                xl={12}
                                xxl={12}
                              >
                                <span className="add-visit-summary-text">
                                  First name:
                                </span>
                                <br />
                                <b className="add-visit-summary-text-value">
                                  {visitor.Forename.length > 0
                                    ? visitor.Forename
                                    : "-"}
                                </b>
                              </Col>
                              <Col
                                xs={24}
                                sm={24}
                                md={10}
                                lg={6}
                                xl={12}
                                xxl={12}
                              >
                                <span className="add-visit-summary-text">
                                  Last name:
                                </span>
                                <br />
                                <b className="add-visit-summary-text-value">
                                  {visitor.Surname.length > 0
                                    ? visitor.Surname
                                    : "-"}
                                </b>
                              </Col>
                            </Row>
                            <Row>
                              <Col
                                xs={24}
                                sm={24}
                                md={10}
                                lg={6}
                                xl={12}
                                xxl={12}
                              >
                                <span className="add-visit-summary-text">
                                  Birth date:
                                </span>
                                <br />
                                {visitor.BirthDate != null
                                  ? new Date(
                                      visitor.BirthDate
                                    ).toLocaleDateString()
                                  : "-"}
                              </Col>
                              <Col
                                xs={24}
                                sm={24}
                                md={10}
                                lg={6}
                                xl={12}
                                xxl={12}
                              >
                                <span className="add-visit-summary-text">
                                  Gender:
                                </span>
                                <br />
                                {visitor.Gender.length > 0
                                  ? visitor.Gender
                                  : "-"}
                              </Col>
                            </Row>
                            <Row>
                              <Col
                                xs={24}
                                sm={24}
                                md={10}
                                lg={6}
                                xl={12}
                                xxl={12}
                              >
                                <span className="add-visit-summary-text">
                                  Address:
                                </span>
                                <br />
                                <p className="add-visit-summary-text-value">
                                  {visitor.Address.length > 0
                                    ? visitor.Address
                                    : "-"}
                                </p>
                              </Col>
                              <Col
                                xs={24}
                                sm={24}
                                md={10}
                                lg={6}
                                xl={12}
                                xxl={12}
                              >
                                <span className="add-visit-summary-text">
                                  City:
                                </span>
                                <br />
                                <p className="add-visit-summary-text-value">
                                  {visitor.City.length > 0 ? visitor.City : "-"}
                                </p>
                              </Col>
                            </Row>
                            <Row>
                              <Col
                                xs={24}
                                sm={24}
                                md={10}
                                lg={6}
                                xl={12}
                                xxl={12}
                              >
                                <span className="add-visit-summary-text">
                                  Phone:
                                </span>
                                <br />
                                <p className="add-visit-summary-text-value">
                                  {visitor.Phone.length > 0
                                    ? visitor.Phone
                                    : "-"}
                                </p>
                              </Col>
                              <Col
                                xs={24}
                                sm={24}
                                md={10}
                                lg={6}
                                xl={12}
                                xxl={12}
                              >
                                <span className="add-visit-summary-text">
                                  Email:
                                </span>
                                <br />
                                <p className="add-visit-summary-text-value">
                                  {visitor.Email.length > 0
                                    ? visitor.Email
                                    : "-"}
                                </p>
                              </Col>
                            </Row>
                            <Row>
                              <Col
                                xs={24}
                                sm={24}
                                md={10}
                                lg={6}
                                xl={12}
                                xxl={12}
                              >
                                <span className="add-visit-summary-text">
                                  Nationality:
                                </span>
                                <br />
                                <p className="add-visit-summary-text-value">
                                  {visitor.Nationality &&
                                  visitor.Nationality.length > 0
                                    ? visitor.Nationality
                                    : "-"}
                                </p>
                              </Col>
                              <Col
                                xs={24}
                                sm={24}
                                md={10}
                                lg={6}
                                xl={12}
                                xxl={12}
                              >
                                <span className="add-visit-summary-text">
                                  Company name:
                                </span>
                                <br />
                                <p className="add-visit-summary-text-value">
                                  {visitor.TravelerComments &&
                                  visitor.TravelerComments.length > 0
                                    ? visitor.TravelerComments
                                    : "-"}
                                </p>
                              </Col>
                            </Row>
                            <Row>
                              <Col
                                xs={24}
                                sm={24}
                                md={10}
                                lg={6}
                                xl={12}
                                xxl={12}
                              >
                                <span className="add-visit-summary-text">
                                Function:
                                </span>
                                <br />
                                <p className="add-visit-summary-text-value">
                                  {visitor.VisitorFunction  &&
                                  visitor.VisitorFunction.length > 0
                                    ? visitor.VisitorFunction 
                                    : "-"}
                                </p>
                              </Col>
                              <Col
                                xs={24}
                                sm={24}
                                md={10}
                                lg={6}
                                xl={12}
                                xxl={12}
                              >
                                <span className="add-visit-summary-text">
                                Contact on board:
                                </span>
                                <br />
                                <p className="add-visit-summary-text-value">
                                  {visitor.ContactPerson  &&
                                  visitor.ContactPerson.length > 0
                                    ? visitor.ContactPerson 
                                    : "-"}
                                </p>
                              </Col>
                            </Row>
                            <Row>
                              <Col
                                xs={24}
                                sm={24}
                                md={10}
                                lg={6}
                                xl={12}
                                xxl={12}
                              >
                                <span className="add-visit-summary-text">
                                License plate:
                                </span>
                                <br />
                                <p className="add-visit-summary-text-value">
                                  {visitor.LicensePlate  &&
                                  visitor.LicensePlate.length > 0
                                    ? visitor.LicensePlate 
                                    : "-"}
                                </p>
                              </Col>
                            </Row>
                          </Col>
                          <Col
                            className="visit-list-group"
                            xs={24}
                            sm={24}
                            md={24}
                            lg={24}
                            xl={10}
                            xxl={8}
                          >
                            <Row>
                              <Col
                                xs={24}
                                sm={24}
                                md={10}
                                lg={6}
                                xl={12}
                                xxl={12}
                              >
                                <span className="add-visit-summary-text">
                                  Document type:
                                </span>
                                <br />
                                <p className="add-visit-summary-text-value">
                                  {visitor.DocumentType.length > 0
                                    ? visitor.DocumentType
                                    : "-"}
                                </p>
                              </Col>
                              <Col
                                xs={24}
                                sm={24}
                                md={10}
                                lg={6}
                                xl={12}
                                xxl={12}
                              >
                                <span className="add-visit-summary-text">
                                  Document number:
                                </span>
                                <br />
                                <p className="add-visit-summary-text-value">
                                  {visitor.DocumentNumber.length > 0
                                    ? visitor.DocumentNumber
                                    : "-"}
                                </p>
                              </Col>
                            </Row>
                            <Row>
                              <Col
                                xs={24}
                                sm={24}
                                md={10}
                                lg={6}
                                xl={12}
                                xxl={12}
                              >
                                <span className="add-visit-summary-text">
                                  First name:
                                </span>
                                <br />
                                <p className="add-visit-summary-text-value">
                                  {visitor.DocumentForename.length > 0
                                    ? visitor.DocumentForename
                                    : "-"}
                                </p>
                              </Col>
                              <Col
                                xs={24}
                                sm={24}
                                md={10}
                                lg={6}
                                xl={12}
                                xxl={12}
                              >
                                <span className="add-visit-summary-text">
                                  Last name:
                                </span>
                                <br />
                                <p className="add-visit-summary-text-value">
                                  {visitor.DocumentSurname.length > 0
                                    ? visitor.DocumentSurname
                                    : "-"}
                                </p>
                              </Col>
                            </Row>
                            <Row>
                              <Col
                                xs={24}
                                sm={24}
                                md={10}
                                lg={6}
                                xl={12}
                                xxl={12}
                              >
                                <span className="add-visit-summary-text">
                                  Place:
                                </span>
                                <br />
                                <p className="add-visit-summary-text-value">
                                  {visitor.DocumentAddress.length > 0
                                    ? visitor.DocumentAddress
                                    : "-"}
                                </p>
                              </Col>
                              <Col
                                xs={24}
                                sm={24}
                                md={10}
                                lg={6}
                                xl={12}
                                xxl={12}
                              >
                                <span className="add-visit-summary-text">
                                  Valid date:
                                </span>
                                <br />
                                {visitor.DocumentValidDate != null
                                  ? new Date(
                                      visitor.DocumentValidDate
                                    ).getMonth() +
                                    1 +
                                    "/" +
                                    new Date(
                                      visitor.DocumentValidDate
                                    ).getFullYear()
                                  : "-"}
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      </Col>
                      <Col
                        className="visit-list-item-button"
                        xs={24}
                        sm={12}
                        md={8}
                        lg={6}
                        xl={6}
                        xxl={4}
                      >
                        <Button disabled>
                          <IdcardOutlined />
                          Boarding Pass
                        </Button>
                      </Col>
                    </Row>
                  ))}
                </Panel>
              </Collapse>
            </List.Item>
          )}
        />
      );
    }
  }

  const menu = (
    <Menu className="visit-list-menu">
      <Menu.Item icon={<IdcardOutlined />}>
        <Button
          disabled
          onClick={(event) => {
            event.stopPropagation();
          }}
          type="link"
        >
          Get all Boarding Pass
        </Button>
      </Menu.Item>
    </Menu>
  );

  return (
    <>
      <div className="visit-list-header">
        <Row>
          <Col span={18} offset={3}>
            <h3>List of your visits</h3>
            {ShowList(visits?.length)}
            <div className="visit-list-link">
              <Link to="/addvisit">add new visit</Link>
            </div>
          </Col>
        </Row>
        <Row>
          <Col span={18} offset={3}></Col>
        </Row>
      </div>
    </>
  );
};

VisitList.displayName = "Visit List";

export default VisitList;
